module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-haven-fluted-balmoral-1.4334bb3a.jpg";